import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Reston Daily · Your Local News Source</p>
        <h1>Stay Informed, Stay Connected.</h1>
        <p className="lede">
          Discover the latest news, events, and stories from Reston. Our platform keeps you updated with
          everything happening in your community, ensuring you never miss a beat.
        </p>
        <div className="cta-row">
          <a href="/news" target="_self">
            Read the Latest News
          </a>
          <a href="/events" target="_self" className="secondary">
            Explore Local Events
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Get real-time updates on the most important stories affecting Reston. Our dedicated team
            brings you the news as it happens.
          </p>
        </article>
        <article>
          <h2>Community Events</h2>
          <p>
            From festivals to local meetings, find out what's happening in your neighborhood and get
            involved with your community.
          </p>
        </article>
        <article>
          <h2>Local Insights</h2>
          <p>
            Dive deeper into the stories that matter. Our features and opinion pieces provide context
            and analysis on local issues.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;